import { render, staticRenderFns } from "./DigitalLiteracy.vue?vue&type=template&id=3b37ad1d&scoped=true&"
import script from "./DigitalLiteracy.vue?vue&type=script&lang=js&"
export * from "./DigitalLiteracy.vue?vue&type=script&lang=js&"
import style0 from "./DigitalLiteracy.vue?vue&type=style&index=0&id=3b37ad1d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b37ad1d",
  null
  
)

export default component.exports